/**
 * Money is fixed-point in kobo throughout the platform — never JS `number`.
 * These helpers convert at the UI boundary only, with explicit precision.
 */

export function koboToNaira(kobo: string): string {
  if (!/^-?\d+$/.test(kobo)) return '—';
  const neg = kobo.startsWith('-');
  const abs = neg ? kobo.slice(1) : kobo;
  const padded = abs.padStart(3, '0');
  const naira = padded.slice(0, -2);
  const fraction = padded.slice(-2);
  const grouped = naira.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return `${neg ? '-' : ''}₦${grouped}.${fraction}`;
}

/** Parse a user-typed price like "43.19" into fixed-point kobo "4319". */
export function nairaToKobo(input: string): string | undefined {
  const trimmed = input.trim();
  if (!/^\d+(\.\d{0,2})?$/.test(trimmed)) return undefined;
  const [whole, fraction = ''] = trimmed.split('.');
  const fracPadded = (fraction + '00').slice(0, 2);
  const out = `${whole}${fracPadded}`.replace(/^0+(?=\d)/, '');
  return out.length === 0 ? '0' : out;
}

export function fmtPct(n: number): string {
  const sign = n > 0 ? '+' : '';
  return `${sign}${n.toFixed(2)}%`;
}

export function fmtTime(iso: string): string {
  const d = new Date(iso);
  if (isNaN(d.getTime())) return iso;
  const hh = String(d.getHours()).padStart(2, '0');
  const mm = String(d.getMinutes()).padStart(2, '0');
  const ss = String(d.getSeconds()).padStart(2, '0');
  return `${hh}:${mm}:${ss}`;
}

export function fmtQty(n: number): string {
  return n.toLocaleString('en-NG');
}

/** Generates a URL-safe id suitable for clOrdId / idempotencyKey. */
export function newId(prefix = 'id'): string {
  const rand = Array.from(crypto.getRandomValues(new Uint8Array(12)))
    .map((b) => b.toString(16).padStart(2, '0')).join('');
  return `${prefix}-${rand}`;
}
